import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["bottomBordersSquare", "fields", "hasNoLayoutCalculation", "isBorderless", "width", "withLayoutSpacing"];
import React from 'react';
import View from '@bubble-ui/primitive-view';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { calculateContent } from './calculateContent';
import { contentWithoutLayoutCalculation } from './contentWithoutLayoutCalculation';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var Fieldset = _ref => {
  var {
      bottomBordersSquare,
      fields,
      hasNoLayoutCalculation,
      isBorderless,
      width,
      withLayoutSpacing
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropDeprecationWarning({
    componentName: 'Fieldset',
    propName: 'hasNoLayoutCalculation',
    shouldWarn: hasNoLayoutCalculation !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Fieldset',
    propName: 'isBorderless',
    shouldWarn: isBorderless !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Fieldset',
    propName: 'bottomBordersSquare',
    shouldWarn: bottomBordersSquare !== undefined,
    removalDate: 'v6.0.0'
  });
  var {
    rootStyle
  } = getDefaultStyleSheet({
    hasNoLayoutCalculation,
    width
  });
  return /*#__PURE__*/React.createElement(View, _extends({}, props, {
    style: rootStyle
  }), hasNoLayoutCalculation ? contentWithoutLayoutCalculation(fields) : calculateContent({
    fields,
    isBorderless,
    bottomBordersSquare,
    withLayoutSpacing
  }));
};
Fieldset.displayName = 'Fieldset';
export default withProvisionalOverrideFromContext(Fieldset);
//# sourceMappingURL=index.js.map